if (!customElements.get('yk-product-inquiry')) {
  customElements.define('yk-product-inquiry', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.pending = false;
      this.onChange = (event) => {
        if (event.target.closest('variant-selects')) {
          this.pending = true;
          this.refresh();
        } else if (event.target.name === 'id') {
          this.pending = false;
          this.refresh();
        } else if (event.target.name === 'quantity') this.refresh();
      };
      this.onClick = () => this.refresh();
      this.info?.addEventListener('change', this.onChange, true);
      this.info?.addEventListener('input', this.onChange, true);
      this.addEventListener('click', this.onClick, true);
      this.refresh();
    }

    disconnectedCallback() {
      this.info?.removeEventListener('change', this.onChange, true);
      this.info?.removeEventListener('input', this.onChange, true);
      this.removeEventListener('click', this.onClick, true);
    }

    selectedVariant() {
      if (!this.info || this.pending) return null;
      const picker = this.info.querySelector('variant-selects');
      const source = picker
        ? picker.querySelector('[data-selected-variant]')
        : this.querySelector('[data-inquiry-initial-variant]');
      try {
        const variant = JSON.parse(source?.textContent || 'null');
        const id = this.info.querySelector('form[id^="product-form-"] input[name="id"]')?.value;
        if (!variant || !id || String(variant.id) !== id) return null;
        return variant;
      } catch { return null; }
    }

    refresh() {
      const variant = this.selectedVariant();
      const input = this.info?.querySelector('input[name="quantity"]');
      const count = input ? Number(input.value) : 1;
      const quantity = Number.isSafeInteger(count) && count > 0 ? count : '[please specify]';
      const sku = variant?.sku?.trim() || '[please specify]';
      const configuration = variant?.title || '[please specify]';
      const productUrl = new URL(this.dataset.url);
      productUrl.search = '';
      productUrl.hash = '';
      if (variant) productUrl.searchParams.set('variant', variant.id);
      const retail = this.dataset.kind === 'retail';
      const body = [
        retail ? 'Hi YKCoffee, I have a question about this product:' : 'Hi YKCoffee, please quote:',
        `Product: ${this.dataset.title}`,
        `SKU: ${sku}`,
        `Configuration: ${configuration}`,
        `Quantity: ${quantity}`,
        'Destination country/postcode: [please specify]',
        `Product reference: ${productUrl.href}`,
        retail ? 'My question: [please add your question]' : 'Please confirm supplied items, compatibility, protective packing and destination freight.'
      ].join('\n');
      const email = this.querySelector('[data-inquiry-channel="email"]');
      const whatsapp = this.querySelector('[data-inquiry-channel="whatsapp"]');
      email.href = `mailto:${this.dataset.email}?subject=${encodeURIComponent(`YKCoffee enquiry - ${this.dataset.title}`)}&body=${encodeURIComponent(body)}`;
      whatsapp.href = `https://wa.me/${this.dataset.whatsapp}?text=${encodeURIComponent(body)}`;
      const status = this.querySelector('[data-inquiry-selection]');
      status.textContent = variant
        ? `Configuration: ${configuration}. SKU: ${sku}.`
        : 'Specify the exact SKU and configuration in your message; the current selection is not confirmed.';
    }
  });
}
